<template>
  <v-text-field
    :label="field.name"
    type="date"
    :rules="fieldRules"
    :model-value="formattedValue"
    :hint="field.description"
    @update:model-value="onInput"></v-text-field>
</template>

<script setup lang="ts">
import { IEntryFieldDTO } from '@/dtos';
import { formatDateFieldInput, rules } from '@/helpers';

import { ref, computed, watch } from 'vue';

const props = defineProps<{
  field: IEntryFieldDTO;
  modelValue?: string;
}>();

const field = props.field;

const fieldRules = ref<((value: string) => true | string)[]>([]);
watch(
  () => field,
  () => {
    fieldRules.value = [];
    if (field.is_required) {
      fieldRules.value.push(rules.required);
    }
  },
  { immediate: true },
);

const formattedValue = computed(() => {
  return props.modelValue ? formatDateFieldInput(props.modelValue) : '';
});

const emit = defineEmits<{
  (e: 'update:modelValue', fieldId: string, value: string): void;
}>();

const onInput = (value: string) => {
  emit('update:modelValue', field.id, value ?? '');
};
</script>
